module.exports = __webpack_public_path__ + "static/media/blueQuote.e62422ca.svg";